import type { Uuid } from '@sibe/utilities/common';
import { HsGraphicObject } from './graphic-object.class';
import type { HsRegularGeometry } from '../../graphic-engine-new/geometry/regular-geometry.class';
import type { HsDefaultShader } from '../shaders/classes/default-shader.class';
import type { HsPointsMaterial } from '../materials/points-material.class';

export class HsGraphicPoints extends HsGraphicObject {
  private pointSize: number = 1;
  private pointSizeFactor: number = 1;
  private resizable: boolean = false;
  /** Set by the host's point cloud draw budget: the block stays loaded but is left out of this frame. */
  public budgetSkipped: boolean = false;
  /**
   * Set by the host's point cloud draw budget: draw only this many of the block's first points, or all of
   * them when null. Decoders interleave point cloud blocks, so any prefix is an even sample.
   */
  public drawCount: number | null = null;

  constructor(
    uuid: Uuid,
    name: string,
    public geometry: HsRegularGeometry,
    public material: HsPointsMaterial<HsDefaultShader>
  ) {
    super(uuid, name, geometry, material);
  }

  public setPointSizeFactor(gl: WebGL2RenderingContext, factor: number): void {
    this.pointSizeFactor = factor;
    this.material.setPointSize(gl, this.pointSize * this.pointSizeFactor);
  }

  public setPointsSize(gl: WebGL2RenderingContext, size: number): void {
    this.pointSize = size;
    this.material.setPointSize(gl, this.pointSize * this.pointSizeFactor);
  }

  public setPointSize(size: number): void {
    this.pointSize = size;
  }

  public setResizable(resizable: boolean): void {
    this.resizable = resizable;
  }

  public getPointSize(): number {
    return this.pointSize;
  }

  /** The size in pixels the points were last drawn with: the point size times the renderer's factor. */
  public getDrawnPointSize(): number {
    return this.pointSize * this.pointSizeFactor;
  }

  public isResizable(): boolean {
    return this.resizable;
  }
}
